import React from "react";
import { PerformanceDash } from "./Performance";
import { NewSearchBar } from "./NewSearchBar";
import { TabBar } from "./../Dashboard/TabBar";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";
import Colors from '../../../Global/colors'

export const NewDashboard = ({
  performanceData_1,
  customGroupData,
  performanceDataPrevious,
  value,
  handleSideBarChange,
  handleSideBarSubmitProgress,
  templates,
  companies,
  inspections,
  sites,
  handleSideBarSubmitProgressPrevious,
  packageDetails,
  btnLoader,
  setBtnLoader,
  openModal,
  setModal
}) => {
  
  return (
    <div className="" style={{display:'flex', flexDirection:'column',padding:'0px', overflow:'hidden',height:"calc(100vh - 50px)",backgroundColor:Colors.globalColor9 }}>
    <div className="" style={{overflowY:'scroll',backgroundColor:Colors.globalColor9, padding:'20px' }}>
 
       <Dialog
          onClose={()=>{setModal("performance",false)}}
          aria-labelledby="max-width-dialog-title"
          open={openModal}
          fullWidth={true}
          maxWidth={"sm"}
          scroll={"paper"}
          className="executiveDashModal"
        >
          <React.Fragment>
            <Grid
              item
              xs={12}
              style={{ alignSelf: "flex-end", cursor: "pointer" }}
              onClick={()=>{setModal("performance",false)}}
            >
              <CloseIcon fontSize="medium" style={{ color: "#043077" }} />
            </Grid>
            <NewSearchBar
            value={value}
            handleSideBarSubmitProgress={handleSideBarSubmitProgress}
            handleSideBarChange={handleSideBarChange}
            templates={templates}
            companies={companies}
            inspections={inspections}
            sites={sites}
            handleSideBarSubmitProgressPrevious={
            handleSideBarSubmitProgressPrevious
        }
        packageDetails={packageDetails}
        btnLoader={btnLoader}
        setBtnLoader={setBtnLoader}
      />
          </React.Fragment>
        </Dialog>
     
      <TabBar active="performance" setModal={setModal}/>
  
      <PerformanceDash
        performanceData_1={performanceData_1}
        customGroupData={customGroupData}
        performanceDataPrevious={performanceDataPrevious}
        setModal={setModal}
      />
    </div>
    </div>
  );
};
